<div class="card-link-success-icon-main-container">
  <div class="card-link-success-icon-container">
    <span class="icon icon3 material-icons">{{ googleIconName3 }}</span>
    <span class="icon icon1 material-icons">{{ googleIconName1 }}</span>
    <span class="icon icon2 material-icons">{{ googleIconName2 }}</span>
  </div>
</div>

<div class="card-link-success-text-btn-container">
  <p class="text-title">{{'fgbcl.card.linking.success.content.title' | translate}}</p>
  <p class="description-text">{{'fgbcl.card.linking.success.content.description' | translate}}</p>
  <button type="button" class="all-offer-btn"
  routerLink="{{routerLink}}"
  >{{'fgbcl.card.linking.success.all.offer.title' | translate}}</button>
</div>
